import type { PlannedGuide, ReferenceGuide } from './types';
import { inventoryGuide } from './inventory';
import { manufacturingGuide } from './manufacturing';
import { procurementGuide } from './procurement';

/**
 * Published guides, in the order they appear on the index.
 * Order is editorial, not alphabetical.
 */
export const referenceGuides: ReferenceGuide[] = [inventoryGuide, manufacturingGuide, procurementGuide];

/** Rendered as the dashed "more guides in progress" tile. Not routable. */
export const plannedGuides: PlannedGuide[] = [{
  status: 'planned',
  title: 'Quality & QMS',
  category: 'Quality'
}, {
  status: 'planned',
  title: 'Sales & Quoting (CPQ)',
  category: 'Sales'
}, {
  status: 'planned',
  title: 'Scheduling & Capacity Planning',
  category: 'Planning'
}, {
  status: 'planned',
  title: 'Costing & the GL',
  category: 'Finance'
}];
export function getGuide(slug: string | undefined): ReferenceGuide | undefined {
  if (!slug) return undefined;
  return referenceGuides.find(g => g.slug === slug);
}

/** Two other guides to surface at the foot of a guide page. */
export function getRelatedGuides(slug: string): ReferenceGuide[] {
  return referenceGuides.filter(g => g.slug !== slug).slice(0, 2);
}
export * from './types';